module.exports = __webpack_public_path__ + "static/media/docka-min.31dafad7.png";